import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughQueueProps = {
  node: ConversationFlowAuditLogEntry<
    | 'EMAIL_QUEUE_NODE_VISITED'
    | 'TELEPHONY_QUEUE_NODE_VISITED'
    | 'MESSENGER_QUEUE_NODE_VISITED'
  >;
};

export function RoutedThroughQueue({
  node,
}: RoutedThroughQueueProps): JSX.Element {
  return (
    <>
      Queue · Added to <strong>{node.label}</strong>
    </>
  );
}
